"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var contests_constants_1 = require("@biw/contests-constants");
var goalquestCodes = tslib_1.__importStar(require("./goalquest-messages"));
var challengepointCodes = tslib_1.__importStar(require("./challengepoint-messages"));
var objectivesCodes = tslib_1.__importStar(require("./objectives-messages"));
var constants_1 = require("./constants");
function getResultMessageCode(programType, resultCode) {
    switch (programType) {
        case contests_constants_1.PT__GQ:
            return goalquestCodes.getResultMessageCode(resultCode);
        case contests_constants_1.PT__CP:
            return challengepointCodes.getResultMessageCode(resultCode);
        case contests_constants_1.PT__OBJ:
            return objectivesCodes.getResultMessageCode(resultCode);
    }
    return constants_1.NO_MESSAGE_CODE;
}
exports.getResultMessageCode = getResultMessageCode;
function getResultSubmessageCode(programType, resultCode) {
    switch (programType) {
        case contests_constants_1.PT__GQ:
            return goalquestCodes.getResultSubmessageCode(resultCode);
        case contests_constants_1.PT__CP:
            return challengepointCodes.getResultSubmessageCode(resultCode);
        case contests_constants_1.PT__OBJ:
            return objectivesCodes.getResultSubmessageCode(resultCode);
    }
    return constants_1.NO_MESSAGE_CODE;
}
exports.getResultSubmessageCode = getResultSubmessageCode;
function getFooterMessageCode(programType, resultCode) {
    switch (programType) {
        case contests_constants_1.PT__GQ:
            return goalquestCodes.getFooterMessageCode(resultCode);
        case contests_constants_1.PT__CP:
            return challengepointCodes.getFooterMessageCode(resultCode);
        case contests_constants_1.PT__OBJ:
            return objectivesCodes.getFooterMessageCode(resultCode);
    }
    return constants_1.NO_MESSAGE_CODE;
}
exports.getFooterMessageCode = getFooterMessageCode;
//# sourceMappingURL=index.js.map